// src/config/seo.js
export const SEO_CONFIG = {
  // Agent Information
  AGENT_NAME: "David Hamady",
  AGENT_EMAIL: "david@granthamadyrealtors.com", 
  AGENT_PHONE: "+1-810-814-0490",
  
  // Business Address
  STREET_ADDRESS: "4265 E. Court St.",
  CITY: "Burton",
  STATE: "MI",
  ZIP_CODE: "48509", 
  COUNTRY: "US",
  
  // Geographic Coordinates
  LATITUDE: "43.0125",
  LONGITUDE: "-83.6875",
  
  // Domain & URLs
  DOMAIN: "davidhamady.com",
  
  // Social Media
  FACEBOOK_URL: "https://www.facebook.com/dhamadyrealtor/",
  TWITTER_HANDLE: "",
  LINKEDIN_URL: "",
  
  // Images  
  OG_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/david.hamady.flint_62e436a10ae14e62bcdca74224f02663.png",
  TWITTER_IMAGE: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/david.hamady.flint_62e436a10ae14e62bcdca74224f02663.png",
  LOGO_URL: "https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/david.hamady.flint_62e436a10ae14e62bcdca74224f02663.png"
};
